// extracted by mini-css-extract-plugin
export default {"NavigationItem":"NavigationItem_NavigationItem__+Dn8y"};